// Auto-generated from welikebikes.de products.json. Real inventory; real product images.
// Only currently-available products with a live product image are included.
window.WLB_BIKES = [
  {
    "id": "sushi-maki-3-0-b-ware-1",
    "name": "Sushi Maki 3.0+ B-Ware",
    "brand": "Sushi",
    "type": "City E-Bike",
    "motor": "250 W Heckmotor 32 Nm",
    "akku": 360,
    "priceFrom": 1000,
    "fitFor": [
      "flach"
    ],
    "color": "#EF4444",
    "imageUrl": "https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_a3154418-c6b7-4b6e-80a9-ee29c330418b.png?v=1781215723",
    "shopUrl": "https://welikebikes.de/products/sushi-maki-3-0-b-ware-1",
    "blurb": "Minimalistisches Pendler-Bike für flache Stadt-Runs."
  },
  {
    "id": "deruiz-turmali-premium-s",
    "name": "Deruiz Turmali Premium S",
    "brand": "Deruiz",
    "type": "City E-Bike",
    "motor": "250 W Heckmotor",
    "akku": 360,
    "priceFrom": 1799,
    "fitFor": [
      "flach",
      "huegelig"
    ],
    "color": "#F59E0B",
    "imageUrl": "https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_75749950-8dbb-4067-9687-31206a7191c4.png?v=1781215442",
    "shopUrl": "https://welikebikes.de/products/deruiz-turmali-premium-s",
    "blurb": "Komfort-Cruiser zum fairen Preis."
  },
  {
    "id": "hepha-performance-1",
    "name": "Hepha Performance",
    "brand": "Hepha",
    "type": "City E-Bike",
    "motor": "250 W Mid-Drive",
    "akku": 360,
    "priceFrom": 2099,
    "fitFor": [
      "flach",
      "huegelig"
    ],
    "color": "#6366F1",
    "imageUrl": "https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_7dd82323-0a5d-448a-83c8-70d9e146b85d.png?v=1781215521",
    "shopUrl": "https://welikebikes.de/products/hepha-performance-1",
    "blurb": "Allrounder mit gutem Drehmoment, faires Preisniveau."
  },
  {
    "id": "hnf-nicolai-sd3-urban-1",
    "name": "HNF Nicolai SD3 Urban",
    "brand": "HNF Nicolai",
    "type": "City E-Bike",
    "motor": "Bosch Performance CX 85 Nm",
    "akku": 500,
    "priceFrom": 2999,
    "fitFor": [
      "flach",
      "huegelig"
    ],
    "color": "#1F2937",
    "imageUrl": "https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_1cded9f4-1adf-4efa-88fd-263f124ae288.png?v=1781215527",
    "shopUrl": "https://welikebikes.de/products/hnf-nicolai-sd3-urban-1",
    "blurb": "Bosch Performance CX, Tiefeinsteiger, robust."
  },
  {
    "id": "velo-de-ville-ceb-591",
    "name": "Velo de Ville CEB 590",
    "brand": "Velo de Ville",
    "type": "City E-Bike",
    "motor": "Bosch Performance / Active",
    "akku": 400,
    "priceFrom": 3261,
    "fitFor": [
      "flach",
      "huegelig"
    ],
    "color": "#0EA5E9",
    "imageUrl": "https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_4b4861d6-06f0-4ee7-ab6f-a040eb800748.png?v=1781215831",
    "shopUrl": "https://welikebikes.de/products/velo-de-ville-ceb-591",
    "blurb": "Klassischer Tourer mit Bosch-Antrieb."
  },
  {
    "id": "ktm-macina-style-741",
    "name": "KTM MACINA STYLE 740",
    "brand": "KTM",
    "type": "City E-Bike",
    "motor": "Bosch Performance CX 85 Nm",
    "akku": 750,
    "priceFrom": 2999,
    "fitFor": [
      "flach",
      "huegelig"
    ],
    "color": "#F97316",
    "imageUrl": "https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_70337707-4b9c-48fb-834b-56c43344d9ba.png?v=1781215600",
    "shopUrl": "https://welikebikes.de/products/ktm-macina-style-741",
    "blurb": "750 Wh Bosch CX, große Reichweite."
  },
  {
    "id": "hnf-nicolai-ud4-all-terrain-1",
    "name": "HNF Nicolai UD4 All-Terrain",
    "brand": "HNF Nicolai",
    "type": "City E-Bike",
    "motor": "Bosch Performance CX 85 Nm",
    "akku": 750,
    "priceFrom": 4499,
    "fitFor": [
      "flach",
      "huegelig",
      "bergig"
    ],
    "color": "#1F2937",
    "imageUrl": "https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_ea8f7103-c5eb-4d03-83f4-6af7d9af7901.png?v=1781215562",
    "shopUrl": "https://welikebikes.de/products/hnf-nicolai-ud4-all-terrain-1",
    "blurb": "All-Terrain SUV mit 750 Wh, top für lange Touren am Berg."
  },
  {
    "id": "hnf-nicolai-ud4-adventure-1",
    "name": "HNF Nicolai UD4 Adventure",
    "brand": "HNF Nicolai",
    "type": "City E-Bike",
    "motor": "Bosch Performance CX 85 Nm",
    "akku": 750,
    "priceFrom": 5490,
    "fitFor": [
      "huegelig",
      "bergig"
    ],
    "color": "#1F2937",
    "imageUrl": "https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_ced3db6f-1ff6-4d7f-940d-600a678bc5ce.png?v=1781215549",
    "shopUrl": "https://welikebikes.de/products/hnf-nicolai-ud4-adventure-1",
    "blurb": "Premium Adventure E-Bike, Bosch CX, 750 Wh."
  },
  {
    "id": "drag-ion-7-2",
    "name": "Drag ION 7.1",
    "brand": "Drag",
    "type": "E-MTB",
    "motor": "Bosch Performance CX 85 Nm",
    "akku": 625,
    "priceFrom": 3898,
    "fitFor": [
      "bergig"
    ],
    "color": "#DC2626",
    "imageUrl": "https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_f84099dc-8a71-4cdf-b659-846e0ccf6605.png?v=1781215510",
    "shopUrl": "https://welikebikes.de/products/drag-ion-7-2",
    "blurb": "Hardtail E-MTB, Bosch CX, für Trail und Berg."
  },
  {
    "id": "velo-de-ville-seb-890",
    "name": "Velo de Ville SEB 890",
    "brand": "Velo de Ville",
    "type": "E-MTB",
    "motor": "Bosch Performance / Active",
    "akku": 625,
    "priceFrom": 4473,
    "fitFor": [
      "huegelig",
      "bergig"
    ],
    "color": "#0EA5E9",
    "imageUrl": "https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_1fe395c8-71f5-421d-86d9-8009bc81bba1.png?v=1781215842",
    "shopUrl": "https://welikebikes.de/products/velo-de-ville-seb-890",
    "blurb": "Sport-Trekking mit MTB-DNA, 625 Wh."
  },
  {
    "id": "tenways-cargo-one-1",
    "name": "Tenways CARGO ONE",
    "brand": "Tenways",
    "type": "Cargo E-Bike",
    "motor": "Mivice / Bafang Mid-Drive",
    "akku": 960,
    "priceFrom": 4999,
    "fitFor": [
      "flach"
    ],
    "color": "#5BC0BE",
    "imageUrl": "https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_2bff1be4-c38b-47bd-816c-90aaf21b6301.png?v=1781215751",
    "shopUrl": "https://welikebikes.de/products/tenways-cargo-one-1",
    "blurb": "Stabiles Cargo, 960 Wh, Heavy-Duty Mid-Drive."
  },
  {
    "id": "butchers-bicycles-mk1-e-gen-3-vario",
    "name": "Butchers & Bicycles MK1-E Gen. 3 vario",
    "brand": "Butchers & Bicycles",
    "type": "Cargo E-Bike",
    "motor": "Shimano EP8 85 Nm",
    "akku": 500,
    "priceFrom": 7200,
    "fitFor": [
      "flach"
    ],
    "color": "#7C3AED",
    "imageUrl": "https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_b7724615-1f8d-4fb8-90d2-39a9ba22e271.png?v=1773862388",
    "shopUrl": "https://welikebikes.de/products/butchers-bicycles-mk1-e-gen-3-vario",
    "blurb": "Premium Long-John Cargo, Shimano EP8, 500 Wh."
  }
];
